// extracted by mini-css-extract-plugin
module.exports = {"SK_Loader":"_2rAXM3RKiGWfTIlEM3yGHi","SK_LdsRing":"_2LbSfnEYy-727OAwBbmZE0","lds-ring":"_1LBiFOdWXBECB4z2L0Lmrd"};